import { DeltaIcon } from './DeltaIcon';

/**
 * author: Google
 * id D4B29470-8EE3-4ED8-BB01-6C942CE7E748
 * name delta
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/delta.svg
 * tags
 * - Math 
 * - Alpha / Numeric 
 */
export const ChangeHistoryIcon = DeltaIcon;
export default ChangeHistoryIcon